/* eslint-disable react/prop-types */
import React from 'react';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import paymentMeanDetailsModal from '@next-common/payment-mean-details-modal';
import { mdModule } from '@next-common/breakpoint';
import { Wrapper } from '../../fragmentHelper/Wrapper';
import { renderReact } from '../../fragmentHelper/renderReactCustom';
import '@next-common/payment-mean-details-modal/build/style.global.css';

const { PaymentMeanDetailsModalContainer } = paymentMeanDetailsModal.containers;
const paymentMeanDetailsModalReducer = paymentMeanDetailsModal.reducer;
const mdReducer = mdModule.reducer;

type PagePropsType = {};

export const serverCanCache = true;

const WrappedPaymentMeanDetailsModal: React.FC<PagePropsType> = () => {
    const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
    const reducer = combineReducers({
        paymentMeanDetailsModal: paymentMeanDetailsModalReducer,
        md: mdReducer,
    });
    const store = createStoreWithMiddleware(reducer);
    return (
        <Provider store={store}>
            <Wrapper>
                <PaymentMeanDetailsModalContainer />
            </Wrapper>
        </Provider>
    );
};

export const renderFunction = renderReact('PaymentMeanDetails', WrappedPaymentMeanDetailsModal);
